<script lang="ts">
  import { t } from '../i18n';
  import Icon from './icons/Icon.svelte';

  // The settings key (S2-16). The sheet itself loads on first use (S4-03, D14: dialogs out of the start bundle).
  let open = $state(false);
</script>

<button
  type="button"
  class="open"
  aria-label={$t('settings.open')}
  title={$t('settings.open')}
  onclick={() => (open = true)}
>
  <Icon name="settings" />
</button>

{#if open}
  {#await import('./SettingsDialog.svelte') then { default: Dialog }}
    <Dialog onclose={() => (open = false)} />
  {/await}
{/if}

<style>
  .open {
    min-width: var(--bar-h);
    display: grid;
    place-items: center;
    border-left: var(--rule-w) solid var(--rule);
    transition: color var(--dur-fast) var(--ease);
  }
  .open:hover {
    color: var(--accent);
  }
</style>
